<template>
  <el-container class="homecontainer">
    <el-aside width="320px">
      <div class="logodiv1">
        <el-image class="logoimg1"
                  style="width: 300px; height: 50px"
                  :src="logoUrl"
                  fit="fit"></el-image>
      </div>
      <div class="logodiv">
        <el-image class="logoimg"
                  style="width: 150px; height: 190px"
                  :src="squareUrl"
                  fit="fit"></el-image>
      </div>
      <div class="asidediv">
        <p class="namep">{{ info.name }}</p>
        <el-image class="logoimg"
                  style="width: 36px; height: 36px"
                  :src="seal"
                  fit="fit"></el-image>
        <div class="emaildiv">
          <div style="text-align: center">
            <a target="_blank"
               class="peointr"
               title="海洋技术科学学院"
               href="http://www.ioisas.cn/"
               style="font-weight: bold; color: white">{{ info.school }}</a>
          </div>
          <div style="text-align: center">
            <a target="_blank"
               class="peointr"
               title="山东省科学院海洋仪器仪表研究所"
               href="http://www.ioisas.cn/"
               style="font-weight: bold; color: white">山东省科学院海洋仪器仪表研究所</a>
          </div>
          <div style="text-align: center">
            <a target="_blank"
               class="peointr"
               title="齐鲁工业大学"
               href="http://www.qlu.edu.cn/"
               style="font-weight: bold; color: white">{{ info.university }}</a>
          </div>
          <div>
            <span style="font-weight: bold">邮件地址:</span> {{ info.email }}
          </div>
          <div>
            <span style="font-weight: bold">办公室:</span> {{ info.office }}
          </div>
          <div>
            <span style="font-weight: bold">地址:</span> {{ info.address }}
          </div>
          <!-- <div>Phone: {{info.phone}}</div> -->
          <div>
            <span style="font-weight: bold">办公电话:</span> {{ info.tel }}
          </div>
        </div>
        <br />
        <div>
          <!-- <a target="_blak"
             href="https://www.revolvermaps.com/livestats/5o430mawl47/"><img src="//rf.revolvermaps.com/h/m/a/7/ff0000/128/25/5o430mawl47.png"
                 width="256"
                 height="120"
                 alt="Map"
                 style="border:0;"></a> -->
          <!-- <a href="https://clustrmaps.com/site/1bhow"  title="Visit tracker"><img src="//www.clustrmaps.com/map_v2.png?d=YWDTlaZEZnWMeU5dExOAtieLsxta-cGh7x8l5qX6IRo&cl=ffffff"
                 width="256"
                 height="160"
                 alt="Map"
                 style="border:0;"/></a> -->
          <!-- <script type='text/javascript' id='clustrmaps' src='//cdn.clustrmaps.com/map_v2.js?cl=c3c3c3&w=192&t=tt&d=YWDTlaZEZnWMeU5dExOAtieLsxta-cGh7x8l5qX6IRo&co=333744&ct=ffffff&cmo=3acc3a&cmn=ff5353'></script> -->
          <a target="_blak"
             href="https://clustrmaps.com/site/1bhow"
             title="Visit tracker">
            <img src="//clustrmaps.com/map_v2.png?cl=ffffff&w=a&t=tt&d=YWDTlaZEZnWMeU5dExOAtieLsxta-cGh7x8l5qX6IRo"
                 width="200"
                 height="100"
                 style="border:0;" />
          </a>
        </div>
        <div class="cright">
          <!-- <p>Copyright <a target="_blak"
               class="peointr"
               href="https://tongji.baidu.com/"
               title="百度统计"
               style="color: gray">&copy;</a> 2015-2022 . Zhijin Qiu.</p> -->
          <p id="login-footer" style="display : inline;"></p>
          <p>All rights reserved. Powered by Vue.js</p>
          <p><a target="_blak"
             href="https://beian.miit.gov.cn"
             title="鲁ICP备2022034466号-1"
             style="color: gray">鲁ICP备2022034466号-1</a></p>
        </div>
        <!-- <div>
          <el-button @click="show2 = !show2">Click Me</el-button>
          <div style="display: flex; margin-top: 10px; height: 400px">
            <transition name="el-zoom-in-center">
              <div v-show="show2" class="transition-box">
                <a target="_blak"
            href="https://clustrmaps.com/site/1bhow"
            title="Visit tracker">
            <img
              src="//clustrmaps.com/map_v2.png?cl=ffffff&w=192&t=tt&d=YWDTlaZEZnWMeU5dExOAtieLsxta-cGh7x8l5qX6IRo&co=333744&ct=ffffff"
              width="256"
              height="160"
              alt="Map"
              style="border: 0"/>
              </a>
              </div>
            </transition>
          </div>
        </div> -->
      </div>
    </el-aside>
    <el-container>
      <el-header class="mainheader">
        <el-menu :default-active="activeIndex"
                 class="el-menu-demo"
                 mode="horizontal"
                 @select="handleSelect"
                 background-color="#333744"
                 text-color="#fff"
                 active-text-color="#ffd04b"
                 :router="true">
          <el-menu-item><a href="https://www.fmiis.com/~qiu/">仇志金</a></el-menu-item>
          <el-menu-item><a href="#Honors">相关奖励</a></el-menu-item>
          <el-menu-item><a href="#Projects">科研项目</a></el-menu-item>
          <!-- <el-menu-item><a href="#Papers">Papers</a></el-menu-item> -->
          <el-submenu index="2">
            <template #title>学术论文</template>
            <el-menu-item><a href="#Journal">
                <font color="white">学术期刊</font>
              </a></el-menu-item>
            <el-menu-item><a href="#Conference">
                <font color="white">学术会议</font>
              </a></el-menu-item>
          </el-submenu>
          <el-menu-item><a href="#Patents">专利</a></el-menu-item>
          <el-menu-item><a href="#Teaching">教学课程</a></el-menu-item>
          <el-menu-item><a href="./tools/tools.html"
               target="_blank">工具箱</a></el-menu-item>
          <!-- <el-menu-item><a href="https://www.qiuzhijin.tk/blog/"
               target="_blank">博客</a></el-menu-item> -->
          <div style="text-align: right; margin-top: 20px; color: white; font-size: 20px;
    font-family: 黑体;">拼搏 务实 开放 创新</div>
        </el-menu>
      </el-header>
      <el-main>
        <div>
          <div>
            <a name="Top"></a>
            <div class="markdown-body">
              <markdown-zhijinqiu> </markdown-zhijinqiu>
            </div>
          </div>
          <!-- <el-divider></el-divider> -->
        </div>
        <div>
          <a name="Honors"></a>
          <div class="markdown-body">
            <markdown-honors> </markdown-honors>
          </div>
          <el-divider></el-divider>
        </div>
        <!-- <div>
          <a name="News"></a>
          <div class="markdown-body">
            <markdown-news> </markdown-news>
          </div>
          <el-divider></el-divider>
        </div> -->
        <div>
          <a name="Projects"></a>
          <div class="markdown-body">
            <markdown-projects> </markdown-projects>
          </div>
          <el-divider></el-divider>
        </div>
        <div>
          <a name="Journal"></a>
          <div class="markdown-body">
            <markdown-journals> </markdown-journals>
          </div>
          <a name="Conference"></a>
          <div class="markdown-body">
            <markdown-conferences> </markdown-conferences>
          </div>
          <el-divider></el-divider>
        </div>
        <div>
          <a name="Patents"></a>
          <div class="markdown-body">
            <markdown-patents> </markdown-patents>
          </div>
          <el-divider></el-divider>
        </div>
        <div>
          <a name="Teaching"></a>
          <div class="markdown-body">
            <markdown-teaching> </markdown-teaching>
          </div>
          <el-divider></el-divider>
        </div>
        <div class="footerspan">
          <span style="font-weight: bold">超链接：</span>
          <span>
            <a href="http://www.qlu.edu.cn/"
               target="_blank"
               class="peointr"
               title="齐鲁工业大学">齐鲁工业大学</a>
          </span>
          <!-- <span>
            <a href="http://www.sdas.org/"
               target="_blank"
               class="peointr"
               title="山东省科学院">山东省科学院</a>
          </span> -->
          <span>
            <a href="http://www.ioisas.cn/"
               target="_blank"
               class="peointr"
               title="山东省科学院海洋仪器仪表研究所">山东省科学院海洋仪器仪表研究所</a>
          </span>
          <span>
            <a href="https://scholar.google.com/"
               target="_blank"
               class="peointr"
               title="Google Scholar">Google Scholar</a>
          </span>
          <span>
            <a href="https://github.com/"
               target="_blank"
               class="peointr"
               title="GitHub">GitHub</a>
          </span>
          <span>
            <a href="https://www.nature.com/"
               target="_blank"
               class="peointr"
               title="Nature">Nature</a>
          </span>
          <span>
            <a href="https://www.sciencemag.org/"
               target="_blank"
               class="peointr"
               title="Science">Science</a>
          </span>
          <span>
            <a href="https://www.aliyun.com/"
               target="_blank"
               class="peointr"
               title="阿里云">阿里云</a>
          </span>
          <!-- <span>
            <a href="http://www.freenom.com/"
               target="_blank"
               class="peointr"
               title="Freenom">Freenom</a>
          </span> -->
          <!-- <span>
            <a href="https://www.cloudflare.com/"
               target="_blank"
               class="peointr"
               title="Cloud Flare">Cloud Flare</a>
          </span> -->
          <span>
            <a href="https://tongji.baidu.com/"
               target="_blank"
               class="peointr"
               title="百度统计">百度统计</a>
          </span>
          <span>
            <a href="https://www.fmiis.com/blog/"
               target="_blank"
               class="peointr"
               title="My Blog">Blog</a>
          </span>
          <span>
            <a href="./software"
               target="_blank"
               class="peointr"
               title="SoftWare">SoftWare</a>
          </span>
          <br>
          <br>
          <div align="center"
               style="color:#C0C0C0">
            科研永无止境，每天一小步，也有新高度！！！！
          </div>
          <!-- <br>
          <div align="center">
            <a href="https://beian.miit.gov.cn"
               target="_blank"
               class="peointr"
               style="color: gray"
               title="鲁ICP备2022034466号-1">鲁ICP备2022034466号-1</a>
          </div> -->
        </div>
      </el-main>
      <!-- <el-footer class="footercontainer">
        <div class="footerspan">
          超链接：
          <span class="reflink"><a href="http://www.qlu.edu.cn/"
               target="_blank"
               class="peointr"
               title="齐鲁工业大学">齐鲁工业大学</a></span>
          <span class="reflink"><a href="http://www.sdas.org/"
               target="_blank"
               class="peointr"
               title="山东省科学院">山东省科学院</a></span>
        </div>
      </el-footer> -->
    </el-container>
  </el-container>
</template>

<script>
import markdownZhijinqiu from '../components/mdfiles/zhijinqiu.md'
// import markdownNews from '../components/mdfiles/news.md'
import markdownHonors from '../components/mdfiles/honors.md'
// import markdownTest from '../components/mdfiles/test.md'
import markdownJournals from '../components/mdfiles/journals.md'
import markdownConferences from '../components/mdfiles/conferences.md'
import markdownProjects from '../components/mdfiles/projects.md'
import markdownPatents from '../components/mdfiles/patents.md'
import markdownTeaching from '../components/mdfiles/teaching.md'

export default {
  setup () { },
  components: {
    markdownZhijinqiu,
    // markdownNews,
    markdownHonors,
    // markdownTest,
    markdownJournals,
    markdownConferences,
    markdownProjects,
    markdownPatents,
    markdownTeaching
  },
  // mounted阶段修改p标签
  mounted () {
    // 页脚年份实时更新
    const p = document.getElementById('login-footer')
    // p.innerText = `Copyright &copy; 2015-${this.getNowYear()} Zhijin Qiu`
    p.innerText = `Copyright © 2015 - ${this.getNowYear()} Zhijin Qiu.`
  },
  data () {
    return {
      show2: false,
      activeIndex: '1',
      activeIndex2: '1',
      // squareUrl: 'https://ss1.baidu.com/9vo3dSag_xI4khGko9WTAnF6hhy/zhidao/wh%3D450%2C600/sign=a587b23df11f3a295a9dddcaac159007/500fd9f9d72a60590cfef2f92934349b023bba62.jpg',
      squareUrl: require('../assets/head.jpeg'),
      logoUrl: require('../assets/logo.png'),
      seal: require('../assets/qzj.png'),
      info: {
        name: '仇志金（Zhijin Qiu）',
        university: '齐鲁工业大学',
        school: '海洋技术科学学院',
        email: 'qzj AT qlu.edu.cn',
        office: '上合园区科研楼B535',
        address: '青岛市胶州市上合示范区汇英街2号',
        phone: '+86 186-6972-3238',
        tel: '+86(532) 5862-8394'
      }
    }
  },
  methods: {
    // getNowYear方法，使用date对象获取当前年份
    getNowYear () {
      const date = new Date()
      return date.getFullYear()
    },
    handleSelect (key, keyPath) {
      // console.log(key, keyPath)
    }
  }
}
</script>

<style lang="less" scoped>
.homecontainer {
  height: 100%;
}

a:link {
  text-decoration: none;
}

.el-aside {
  background-color: #333744;
  // color: #333;
}

.cright {
  color: gray;
  line-height: 1;
  font-size: 3px;
}

.el-header {
  background-color: #333744;
  // color: #333;
}

.el-main {
  margin-top: 0px;
  line-height: 25px;
  text-align: left;
  // background-color: #fff;
}

.footercontainer {
  height: 60px;
}

.reflink {
  font-size: 16px;
  color: gray;
}

.el-menu {
  margin-left: 105px;
  vertical-align: middle;
}

.logodiv {
  margin-top: 80px;
  text-align: center;
  height: 180px;
  .logoimg {
    border-radius: 10px;
  }
}

.logodiv1 {
  margin-top: 5px;
  text-align: center;
  height: 3px;
  .logoimg1 {
    border-radius: 1px;
  }
}

.asidediv {
  margin: 0px;
  color: #fff;
  text-align: center;
  vertical-align: top;
  line-height: 25px;
  font-size: 16px;
  .namep {
    font-size: 20px;
    font-weight: bold;
    line-height: 12px;
  }
  .emaildiv {
    text-align: left;
    margin-left: 6px;
  }
}

.footerspan {
  span {
    margin-left: 15px;
  }
}

.transition-box {
  margin-bottom: 0px;
  width: 256px;
  height: 160px;
  // border-radius: 4px;
  background-color: #ff0000;
  text-align: center;
  color: #fff;
  padding: 1px 1px;
  // box-sizing: border-box;
  // margin-right: 0px;
  margin: 0 auto;
}

// .markdown-body h1,
// .markdown-body h2,
// .markdown-body h3,
// .markdown-body h4,
// .markdown-body h5,
// .markdown-body h6 {
//   margin-top: 0px;
//   margin-bottom: 0px;
// }
</style>
